export default __webpack_public_path__ + "static/media/office-training-bg2.8ed13b01.png";